export default function prepCurrentEntity(current, cameras, markups, floorPlans, entities) {
  const { type, id } = current
  if (!id && id !== 0) return { type: 'map' }

  switch (type) {
    case 'map':
      return { type: 'map' }
    case 'camera':
      return cameras.find(c => c.id === id) ? current : { type: 'map' }
    case 'floorPlan':
      return floorPlans.find(f => f.id === id) ? current : { type: 'map' }
    case 'door':
      return entities.doors.byId[id] ? current : { type: 'map' }
    case 'doorController':
      return entities.doorControllers.byId[id] ? current : { type: 'map' }
    case 'networkCloset':
      return entities.networkClosets.byId[id] ? current : { type: 'map' }
    case 'wiredDevice':
      return entities.wiredDevices.byId[id] ? current : { type: 'map' }
    case 'wire':
      return entities.wires.byId[id] ? current : { type: 'map' }
    case 'label':
    case 'circle':
    case 'polygon':
    case 'polyline':
    case 'rectangle':
    case 'wall':
      return markups.find(m => m.id === id && m.type == type) ? current : { type: 'map' }
    default:
      return { type: 'map' }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/projects/prepCurrentEntity.js